<template>
  <!-- <header v-if="content"> -->
  <header v-if="screenContent">
    <div v-if="screenContent.Logo" @click="clickLogo" class="pagelink">
      <picture>
        <source srcset="@/assets/images/logo.webp 300w" type="image/webp" sizes="300px" />
        <img
          class="logo"
          alt="Logo"
          :src="screenContent.Logo"
          :srcset="`${screenContent.Logo} 300w`"
          width="304"
          height="120"
          sizes="300px"
        />
      </picture>
      <!-- :src="apiDomain + content.Logo" -->
    </div>
    <a
      v-if="screenContent.ButtonUrl && !hidePlayFreeNow"
      :href="screenContent.ButtonUrl"
      class="gamelink pagelink btn btn--yellow"
      target="_blank"
      rel="noreferrer"
      @click="playFree"
    >
      <span class="gamelink__lg">{{ screenContent.ButtonText }}</span>
      <span class="gamelink__sm">{{ screenContent.MobileButtonText }}</span>
    </a>
  </header>
</template>

<script>
import Util from '@/services/browser/Util'

export default {
  name: 'Header',
  props: {
    hidePlayFreeNow: {
      type: Boolean,
      default: false, // hide the play free now for the a/b test first scene (Nightv2 component)
    }
  },
  computed: {
    screenContent() {
      return this.$store.getters.getContentHome
    },
    sceneName() {
      return this.$store.getters.getSceneName
    },
  },
  methods: {
    clickLogo() {
      this.$gtm.trackEvent({
        event: 'Logo Click',
        lp_section: this.sceneName,
      })
      // this.$store.dispatch('setScene', 'night')
      window.location.href = '/'
    },
    playFree: function (e) {
      e.preventDefault()
      this.$gtm.trackEvent({
        event: 'Play Free Now Click',
        lp_section: this.sceneName,
      })
      Util.playFree()
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/mixins.scss';

header {
  position: absolute;
  z-index: 2;
  top: 0;
  width: 100%;
}
.logo {
  position: absolute;
  z-index: 1;
  top: 15px;
  left: calc(50% - 50px);
  width: 100px;

  @include breakpoint(md) {
    top: 20px;
    left: calc(50% - 68px);
    width: 136px;
  }
}
.gamelink {
  position: absolute;
  z-index: 1;
  top: 15px;
  right: 15px;

  @include breakpoint(md) {
    top: 30px;
    right: 30px;
  }
}
.gamelink__sm {
  display: block;

  @include breakpoint(md) {
    @include breakpointHeight(md) {
      display: none;
    }
  }
}
.gamelink__lg {
  display: none;

  @include breakpoint(md) {
    @include breakpointHeight(md) {
      display: block;
    }
  }
}

@media only screen and (max-height: 440px) and (orientation: landscape) {
  .logo {
    width: 100px;
    left: calc(50% - 50px);
  }
  .logo,
  .gamelink {
    top: 15px;
  }
}
@media only screen and (max-height: 375px) and (orientation: landscape) {
  .logo,
  .gamelink {
    top: 10px;
  }
}
</style>
